import {
  CustomCalendarType,
  defaultCustomCalendarTypeValues,
  SimpleActivity,
} from "@ac-expo/api-types";
import { FileType } from "@prisma/client";
import { cn } from "@ui/utils";
import MobilePlanningComponent from "./MobilePlanningComponent";
import PlanningComponent from "./PlanningComponent";
import { EventSchedulesTimes, PlanningEvent } from "./utils";

type PlanningProps = {
  activities: SimpleActivity[];
  eventSchedules?: EventSchedulesTimes[];
  className?: string;
  isRegisterEnabled?: boolean;
  openActivitiesDetails?: (events: PlanningEvent[]) => void;
  isEmbedded?: boolean;
  customCalendar?: CustomCalendarType;
  getFileUrl?: (key?: string, type?: FileType, width?: number) => string;
};

const defaultGetFileUrl = () => "";

const Planning = ({
  activities,
  isRegisterEnabled,
  eventSchedules,
  className,
  openActivitiesDetails,
  isEmbedded,
  customCalendar = defaultCustomCalendarTypeValues,
  getFileUrl = defaultGetFileUrl,
}: PlanningProps) => {
  return (
    <div className={cn("flex flex-col", className)}>
      <div
        className={cn(
          "flex flex-1 flex-col",
          isEmbedded ? "" : "hidden lg:block"
        )}
      >
        <PlanningComponent
          activities={activities}
          eventSchedules={eventSchedules}
          onOpenActivitiesDetails={openActivitiesDetails}
          isRegisterEnabled={isRegisterEnabled}
          customCalendar={customCalendar}
          getFileUrl={getFileUrl}
        />
      </div>
      {!isEmbedded && (
        <div className="lg:hidden">
          <MobilePlanningComponent
            activities={activities}
            eventSchedules={eventSchedules}
            onOpenActivitiesDetails={openActivitiesDetails}
            isRegisterEnabled={isRegisterEnabled}
            customCalendar={customCalendar}
            getFileUrl={getFileUrl}
          />
        </div>
      )}
    </div>
  );
};

export default Planning;
